import React from 'react'
import './UpdateProduct.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
const UpdateProduct = () => {
    const [state, setState] = useState(0)
    function onclickBtn() {
        if (state === 1) {
            document.getElementById('mainform').style.display = 'none'
            document.getElementById('updateStock').style.display = 'block'
        }
        else if (state === 2) {
            document.getElementById('mainform').style.display = 'none'
            document.getElementById('updatePrice').style.display = 'block'
        }
        else {
            document.getElementById('mainform').style.display = 'none'
            document.getElementById('updateDiscount').style.display = 'block'
        }

    }
    function onClickBack() {
        if (state === 1) {
            document.getElementById('mainform').style.display = 'block'
            document.getElementById('updateStock').style.display = 'none'
        }
        else if (state === 2) {
            document.getElementById('mainform').style.display = 'block'
            document.getElementById('updatePrice').style.display = 'none'
        }
        else {
            document.getElementById('mainform').style.display = 'block'
            document.getElementById('updateDiscount').style.display = 'none'
        }
    }
    return (
        <>
            <section id="hero">
                <div className="hero-container">
                    <div className="hero-logo row">
                        <h1 className="font-weight-bold col">Update Stocks</h1>
                    </div>
                </div>
            </section>
            <div className="form-container" id='mainform'>
                <form action="" className="checkout-form">
                    <div className="input-line">
                        <label htmlFor="title">Title</label>
                        <input type="text" name="title" id="title" placeholder="Title of the Product" />
                    </div>
                    <div className="input-line">
                        <label htmlFor="category">Category</label>
                        <input type="text" name="category" id="category" placeholder="Category of the Product" />
                    </div>
                    <div className="input-container">
                        <div className="input-line">
                            <label htmlFor="brand">Brand</label>
                            <input type="text" name="brand" id="brand" placeholder="Brand of the Product" />
                        </div>
                        <div className="input-line">
                            <label htmlFor="model">Model</label>
                            <input type="text" name="model" id="model" placeholder="Model of the Product" />
                        </div>
                    </div>
                </form>
                
            </div>
            <div className='updateStock form-container' id='updateStock'>
                <div className="input-line">
                    <label htmlFor="Available Stock">Available Stock</label>
                    <input type="text" name="availableStock" id="availableStock" />
                </div>
                <div className="input-line">
                    <label htmlFor="Updated Value">Updated Stock</label>
                    <input type="text" name="updatedvalue" id="updatedvalue" placeholder="Enter the updated stock of the product" />
                </div>
                <div className="hstack">
                    <div className="updatebtnBACK">
                        <button type='button' className='btn btn-success' onClick={() => { onClickBack() }}>Back</button>
                    </div>
                    <div className="updatekbtnUPDATE">
                        <button type='button' className='btn btn-success'>Update</button>
                    </div>
                </div>
            </div>
            <div className='updatePrice form-container' id='updatePrice'>
                <div className="input-line">
                    <label htmlFor="Previous Price">Previous Price</label>
                    <input type="text" name="previousPrice" id="previousPrice" />
                </div>
                <div className="input-line">
                    <label htmlFor="Updated Price">Updated Price</label>
                    <input type="text" name="updatedprice" id="updatedprice" placeholder="Enter the updated price of the product" />
                </div>
                <div className="hstack">
                    <div className="updatebtnBACK">
                        <button type='button' className='btn btn-success' onClick={() => { onClickBack() }}>Back</button>
                    </div>
                    <div className="updatebtnUPDATE">
                        <button type='button' className='btn btn-success'>Update</button>
                    </div>
                </div>
            </div>
            <div className='updateDiscount form-container' id='updateDiscount'>
                <div className="input-line">
                    <label htmlFor="Previous Discount">Previous Discount</label>
                    <input type="text" name="previousDiscount" id="previousDiscount" />
                </div>
                <div className="input-line">
                    <label htmlFor="Updated Discount">Updated Discount</label>
                    <input type="text" name="updatedDiscount" id="updatedDiscount" placeholder="Enter the updated discount of the product" />
                </div>
                <div className="hstack">
                    <div className="updatebtnBACK">
                        <button type='button' className='btn btn-success' onClick={() => { onClickBack() }}>Back</button>
                    </div>
                    <div className="updatebtnUPDATE">
                        <button type='button' className='btn btn-success'>Update</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdateProduct